const enum PaymentGateway {
  STRIPE = "stripe",
  ARCOPAY = "arcopay",
  CLOUD_PAYMENTS = "cloud-payments",
}

export default PaymentGateway;
